import DateRangeIcon from '@mui/icons-material/DateRange';
import UpdateIcon from '@mui/icons-material/Update';

import i18n from 'FRONTEND/utils/i18n';

/* eslint-disable max-len */


export const getSlotStepSupport = () => {
  return {
    title: i18n._('How to find a slot?'),
    text: i18n._('The slot that you choose will be the date and time at which the appointment will be set in the participants calendars.'),
    paragraphList: [
      {
        title: i18n._('Set the appointment duration'),
        text: i18n._('The duration displayed in blue is the one defined by the practitioner. However, you can change this duration by selecting from the drop-down menu of the "Appointment duration" field. The selected duration will be used to find the slots in the practitioner’s calendar.'),
        icon: UpdateIcon,
      },
      {
        title: i18n._('Browse other weeks'),
        text: i18n._('If the "Next" button is not disabled, it means that some slots may be available in the upcoming weeks.'),
        icon: DateRangeIcon,
      },
    ],
  };
};
